import { StudentCreditUsageApi } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    creditUsages: [],
    count: 0,
    itemsPerPage: 10,
    query: {},
    loading: false,
  },
  actions: {
    async fetch({ commit }, params) {
      const res = await StudentCreditUsageApi.fetch({
        ...params,
        queueStatus: 'succ',
        _sort: 'createdAt:DESC',
      })
      commit('setCreditUsages', res)
      return res
    },
    async countItems({ commit }, params) {
      const res = await StudentCreditUsageApi.count({ ...params, queueStatus: 'succ' })
      commit('setCount', res)
      return res
    },
    setItemsPerPage({ commit }, data) {
      commit('setItemsPerPage', data)
    },
  },
  mutations: {
    setCreditUsages(state, payload) {
      state.creditUsages = payload
    },
    setCount(state, payload) {
      state.count = payload
    },
    setItemsPerPage(state, data) {
      state.itemsPerPage = data
    },
    setQuery(state, data) {
      state.query = data
    },
    setLoading(state, data) {
      state.loading = data
    },
  },
  getters: {},
}
